import React from 'react';

import liveChatOperatorResponseStyles from './AlmeLiveChatOperatorResponse.styles';

import { withStyles, WithStyles } from '@material-ui/core/styles';

import { ButtonProps } from '@material-ui/core';
import AlmeConfigFormControl, { ConfigControlGroups } from '../../../AlmeConfigFormControl/AlmeConfigFormControl';
import { AlmeLiveChatOperatorResponseConfig } from './AlmeLiveChatOperatorResponseConfig';

interface AlmeLiveChatOperatorResponseConfigToolProps extends WithStyles<typeof liveChatOperatorResponseStyles> {
    almeConfig: AlmeLiveChatOperatorResponseConfig;
    onConfigChange: (almeConfig: AlmeLiveChatOperatorResponseConfig) => void;
}

const AlmeLiveChatOperatorResponseConfigTool: React.FC<AlmeLiveChatOperatorResponseConfigToolProps> = (props: AlmeLiveChatOperatorResponseConfigToolProps) => {
    const displayLinkColor = props.almeConfig.liveChatOperatorResponse.styles.displayLink.color;
    const displayLinkVariant = props.almeConfig.liveChatOperatorResponse.styles.displayLink.variant;
    const navUrlColor = props.almeConfig.liveChatOperatorResponse.styles.navUrl.color;
    const navUrlVariant = props.almeConfig.liveChatOperatorResponse.styles.navUrl.variant;

    const setDisplayLinkColor = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as ButtonProps['color'];
        const almeConfig = props.almeConfig;
        almeConfig.liveChatOperatorResponse.styles.displayLink.color = newValue;
        props.onConfigChange(almeConfig);
    };

    const setDisplayLinkVariant = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as ButtonProps['variant'];
        const almeConfig = props.almeConfig;
        almeConfig.liveChatOperatorResponse.styles.displayLink.variant = newValue;
        props.onConfigChange(almeConfig);
    };

    const setNavUrlColor = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as ButtonProps['color'];
        const almeConfig = props.almeConfig;
        almeConfig.liveChatOperatorResponse.styles.navUrl.color = newValue;
        props.onConfigChange(almeConfig);
    };

    const setNavUrlVariant = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = (event.target as HTMLInputElement).value as ButtonProps['variant'];
        const almeConfig = props.almeConfig;
        almeConfig.liveChatOperatorResponse.styles.navUrl.variant = newValue;
        props.onConfigChange(almeConfig);
    };

    const configControls: ConfigControlGroups[] = [
        {
            name: 'Display Link',
            controlGroups: [
                {
                    label: 'Display Link Color',
                    name: 'displayLinkColor',
                    value: displayLinkColor,
                    changeHandler: setDisplayLinkColor,
                    radioButtons: ['inherit', 'default', 'primary', 'secondary'],
                },
                {
                    label: 'Display Link Variant',
                    name: 'displayLinkVariant',
                    value: displayLinkVariant,
                    changeHandler: setDisplayLinkVariant,
                    radioButtons: ['text', 'outlined', 'contained'],
                },
            ],
        },
        {
            name: 'Nav Url',
            controlGroups: [
                {
                    label: 'Nav Url Color',
                    name: 'navUrlColor',
                    value: navUrlColor,
                    changeHandler: setNavUrlColor,
                    radioButtons: ['inherit', 'default', 'primary', 'secondary'],
                },
                {
                    label: 'Nav Url Variant',
                    name: 'navUrlVariant',
                    value: navUrlVariant,
                    changeHandler: setNavUrlVariant,
                    radioButtons: ['text', 'outlined', 'contained'],
                },
            ],
        },
    ];

    return (
        <AlmeConfigFormControl title='Alme Live Chat Operator Response Config' configControls={configControls} />
    );
};

export default withStyles(liveChatOperatorResponseStyles)(AlmeLiveChatOperatorResponseConfigTool);
